import { DeaconStylesCSS } from "./styles-css";
export function initialHTML() {
    document.querySelector(".deacons-details").innerHTML = `
        ${DeaconStylesCSS()}
        <p><input disabled="disabled" placeholder="Search deacons or duties" id="deacon-search" /></p>
        <div class="deacons-container">Loading...</div>
    `;
}
